import { create } from 'zustand';

export interface ToastEntry {
  id: number;
  message: string;
  tone: 'info' | 'error' | 'success';
}

interface ToastState {
  items: ToastEntry[];
  push: (message: string, tone?: ToastEntry['tone']) => number;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToast = create<ToastState>((set, get) => ({
  items: [],
  push(message, tone = 'info') {
    const id = nextId++;
    set({ items: [...get().items, { id, message, tone }] });
    setTimeout(() => get().dismiss(id), 4000);
    return id;
  },
  dismiss(id) {
    set({ items: get().items.filter((t) => t.id !== id) });
  },
}));
